import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const AdvisorsWrapper = styled('div')({});

export const AdvisorCardContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    padding: '20px 0',
    borderTop: '1px solid #ebedf0',
    '& .advisor-card-profile': {
      marginLeft: '-19px',
      cursor: 'pointer'
    },
    '.advisor-card-details': {
      marginLeft: '2px',
      marginTop: '10px !important',
      paddingTop: '0 !important',
      cursor: 'pointer',
      '& .advisor-review': {
        paddingTop: 0
      },
      '& .offer-price': {
        paddingTop: 0
      },
      '& .no-feedback': {
        fontSize: '16px',
        lineHeight: '14px'
      },
      '.second-line': {
        fontSize: '12px',
        lineHeight: '14px',
        marginTop: '3px'
      }
    },

    '@media (max-width: 320px) ': {
      '.advisor-card-details': {
        '.second-line': {
          fontSize: '11px',
          marginTop: '1px'
        },
        '& .no-feedback': {
          fontSize: '14px'
        }
      }
    },
    '@media (min-width: 481px) ': {
      '.advisor-card-details': {
        '.second-line': {
          marginTop: 0
        },
        '& .no-feedback': {
          fontSize: '20px',
          lineHeight: '23px'
        }
      }
    },
    [theme.breakpoints.up('sm')]: {
      padding: '24px 0',
      '.advisor-card-price-call-chat-container': {
        marginLeft: '17.30%',
        marginTop: '11px'
      },
      '.advisor-data': {
        marginLeft: '-13px',
        marginTop: '-5px'
      },
      '.advisor-card-details': {
        marginLeft: '17.60%',
        '.second-line': {
          marginTop: 0
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      '.advisor-card-details': {
        margin: 0,
        paddingLeft: '12px !important',
        '& .no-feedback': {
          fontSize: '22px'
        },
        '.second-line': {
          fontSize: '14px',
          marginTop: '2px'
        },
        '.advisor-readings': {
          marginTop: '5px',
          '.second-line': {
            marginTop: '1px'
          }
        },
        '.advisor-since': {
          marginTop: '5px',
          '.second-line': {
            marginTop: '1px'
          }
        }
      },
      '.advisor-card-price-call-chat-container': {
        margin: 0,
        padding: '8px 4px 0 23px'
      },
      '.advisor-data': {
        marginLeft: 0,
        marginTop: '4px',
        paddingRight: '4px',
        paddingLeft: '22px'
      }
    },
    [theme.breakpoints.up('lg')]: {
      '.advisor-data': {
        paddingLeft: '16px'
      },
      '.advisor-card-details': {
        paddingLeft: '14.5px !important'
      },
      '.advisor-card-price-call-chat-container': {
        paddingRight: 0,
        paddingLeft: '41px !important',
        paddingTop: '8px !important'
      }
    }
  })
);

export const AdvisorName = styled('span')(({ theme }: { theme?: Theme }) => ({
  '& a': {
    display: 'block',
    fontSize: '20px',
    textDecoration: 'none',
    color: 'teal',
    lineHeight: 1,
    [theme.breakpoints.up('sm')]: {
      fontSize: '24px'
    }
  }
}));

export const AdvisorPitch = styled('span')(({ theme }: { theme?: Theme }) => ({
  display: 'block',
  marginTop: '10px',
  fontSize: '16px',
  fontWeight: 500,
  color: theme.palette.text.primary,
  lineHeight: '22px',
  wordBreak: 'break-word',
  paddingRight: '9px',
  [theme.breakpoints.up('sm')]: {
    marginTop: '15px'
  }
}));

export const AdvisorDescription = styled('span')(
  ({ theme }: { theme?: Theme }) => ({
    display: 'block',
    fontSize: '16px',
    fontWeight: 400,
    marginTop: '12px',
    lineHeight: '1.5',
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    paddingRight: '5px'
  })
);

export const DataPairWrapper = styled('div')({
  marginTop: '20px',
  '&:first-of-type': {
    marginTop: '0'
  }
});

export const FirstLine = styled('div')(({ theme }: { theme?: Theme }) => ({
  fontSize: '22px',
  lineHeight: '25px',
  [theme.breakpoints.down('md')]: {
    fontSize: '11px'
  }
}));

export const SecondLine = styled('div')(({ theme }: { theme?: Theme }) => ({
  color: theme.palette.text.disabled,
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'uppercase'
}));

export const CallButtonContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    '& button': {
      minWidth: '92.5%',
      maxWidth: '92.5%',
      padding: '4px 22px 4px 26px',
      fontSize: '16px',
      fontWeight: '400 !important',
      marginTop: '10px',
      marginLeft: '2px',
      '& .icon': {
        fontSize: '22px'
      },
      '&.send-mail': {
        padding: '3px 16px 3px 20px'
      },
      '&.arrange-call': {
        padding: '3px 6px 3px 10px',
        borderColor: theme.palette.primary.main
      }
    },
    '@media (max-width: 320px) ': {
      '& button': {
        minWidth: '145px',
        maxWidth: '145px',
        padding: '4px 22px 4px 27px',
        marginTop: '11px',
        '&.send-mail': {
          padding: '3px 18px 3px 22px',
          marginTop: '12px'
        },
        '&.arrange-call': {
          padding: '3px 9px 3px 12px'
        }
      }
    },
    '@media (min-width: 481px) ': {
      '& button': {
        minWidth: '95%',
        maxWidth: '95%'
      }
    },
    [theme.breakpoints.up('sm')]: {
      '& button': {
        padding: '6px 24px 6px 28px',
        minWidth: '95.4%',
        maxWidth: '95.4%',
        '& .icon': {
          fontSize: '24px'
        },
        '&.send-mail': {
          padding: '5px 16px 5px 20px'
        },
        '&.arrange-call': {
          padding: '5px 6px 5px 10px'
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      '& button': {
        padding: '6px 22px 6px 25px',
        minWidth: '98.5%',
        maxWidth: '98.5%',
        marginLeft: 0,
        marginTop: '12px'
      }
    },
    [theme.breakpoints.up('lg')]: {
      '& button': {
        fontSize: '18px',
        padding: '4px 8px 4.5px'
      }
    }
  })
);

export const ChatButtonContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    '& .chat-later-container': {
      cursor: 'not-allowed',
      marginTop: '10px',
      '@media (max-width: 320px) ': {
        marginTop: '11px'
      },
      [theme.breakpoints.up('md')]: {
        marginTop: '12px'
      },
      '& button': {
        marginTop: 0
      }
    },
    '& button': {
      minWidth: '92.5%',
      maxWidth: '92.5%',
      padding: '4px 20px 4px 24px',
      fontSize: '16px',
      fontWeight: '400 !important',
      marginTop: '10px',
      marginLeft: '7.5%',
      ':disabled': {
        backgroundColor: theme.palette.text.disabled,
        borderBottomColor: theme.palette.text.disabled,
        opacity: '0.65'
      },
      '& .icon': {
        fontSize: '22px'
      },
      '&.chat-later': {
        padding: '4px 16px 4px 20px'
      }
    },
    '@media (max-width: 320px) ': {
      '& button': {
        minWidth: '145px',
        maxWidth: '145px',
        padding: '4px 20px 4px 24px',
        marginLeft: '6px',
        marginTop: '11px',
        '&.chat-later': {
          padding: '4px 18px 4px 22px'
        }
      }
    },
    '@media (min-width: 481px) ': {
      '& button': {
        width: '95%'
      }
    },
    [theme.breakpoints.up('sm')]: {
      '& button': {
        padding: '6px 24px 6px 29px',
        minWidth: '95.7%',
        maxWidth: '95.7%',
        marginLeft: '7px',
        '& .icon': {
          fontSize: '24px'
        },
        '&.chat-later': {
          padding: '6px 16px 6px 20px'
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      '& button': {
        padding: '6px 22px 6px 25px',
        minWidth: '98.5%',
        maxWidth: '98.5%',
        marginLeft: 0,
        marginTop: '12px'
      }
    },
    [theme.breakpoints.up('lg')]: {
      '& button': {
        fontSize: '18px',
        padding: '4px 8px 4.5px',
        '&.chat-later': {
          padding: '4px 16px 4.5px 20px'
        }
      }
    }
  })
);

export default AdvisorsWrapper;
